/**
 * STICKER CHARACTERS V4 - AVISOCAR
 * =================================
 * Animated characters for premium sticker customization
 */

export const STICKER_CHARACTERS = [
  // Creativos
  { id: "hero_smile", emoji: "😎", category: "creativo", animation: "bounce", name: "Cool Guy" },
  { id: "oops_face", emoji: "😅", category: "creativo", animation: "float", name: "Oops" },
  { id: "wink", emoji: "😉", category: "creativo", animation: "pulse", name: "Wink" },
  { id: "thinking", emoji: "🤔", category: "creativo", animation: "float", name: "Pensando" },
  { id: "star_eyes", emoji: "🤩", category: "creativo", animation: "bounce", name: "Estrellado" },
  
  // Vehículos
  { id: "car_red", emoji: "🚗", category: "vehiculo", animation: "float", name: "Auto" },
  { id: "car_sport", emoji: "🏎️", category: "vehiculo", animation: "bounce", name: "Deportivo" },
  { id: "moto", emoji: "🏍️", category: "vehiculo", animation: "float", name: "Moto" },
  { id: "truck", emoji: "🚚", category: "vehiculo", animation: "pulse", name: "Camión" },
  { id: "parking", emoji: "🅿️", category: "vehiculo", animation: "pulse", name: "Parking" },
  
  // Emergencia
  { id: "siren", emoji: "🚨", category: "emergencia", animation: "pulse", name: "Sirena" },
  { id: "ambulance", emoji: "🚑", category: "emergencia", animation: "bounce", name: "Ambulancia" },
  { id: "warning", emoji: "⚠️", category: "emergencia", animation: "pulse", name: "Alerta" },
  { id: "sos", emoji: "🆘", category: "emergencia", animation: "pulse", name: "SOS" },
  { id: "medical", emoji: "🏥", category: "emergencia", animation: "float", name: "Hospital" },
  
  // Mascotas
  { id: "dog", emoji: "🐕", category: "mascota", animation: "bounce", name: "Perro" },
  { id: "cat", emoji: "🐱", category: "mascota", animation: "float", name: "Gato" },
  { id: "paw", emoji: "🐾", category: "mascota", animation: "pulse", name: "Patita" },
  { id: "puppy_face", emoji: "🐶", category: "mascota", animation: "bounce", name: "Cachorro" },
  
  // Niños
  { id: "child", emoji: "🧒", category: "nino", animation: "float", name: "Niño" },
  { id: "family", emoji: "👨‍👩‍👧", category: "nino", animation: "pulse", name: "Familia" },
  { id: "baby", emoji: "👶", category: "nino", animation: "float", name: "Bebé" },
  { id: "angel", emoji: "👼", category: "nino", animation: "float", name: "Angelito" },
  
  // Viajes
  { id: "plane", emoji: "✈️", category: "viaje", animation: "float", name: "Avión" },
  { id: "luggage", emoji: "🧳", category: "viaje", animation: "bounce", name: "Maleta" },
  { id: "backpack", emoji: "🎒", category: "viaje", animation: "bounce", name: "Mochila" },
  { id: "world", emoji: "🌍", category: "viaje", animation: "pulse", name: "Mundo" },
  
  // Objetos
  { id: "key", emoji: "🔑", category: "objeto", animation: "float", name: "Llave" },
  { id: "phone", emoji: "📱", category: "objeto", animation: "pulse", name: "Teléfono" },
  { id: "gift", emoji: "🎁", category: "objeto", animation: "bounce", name: "Regalo" },
  { id: "heart", emoji: "❤️", category: "objeto", animation: "pulse", name: "Corazón" },
  
  // Privacidad
  { id: "lock", emoji: "🔒", category: "privacidad", animation: "pulse", name: "Candado" },
  { id: "shield", emoji: "🛡️", category: "privacidad", animation: "float", name: "Escudo" },
  { id: "spy", emoji: "🕵️", category: "privacidad", animation: "float", name: "Espía" },
  
  // Premium LATAM
  { id: "peru_flag", emoji: "🇵🇪", category: "latam", animation: "float", name: "Perú" },
  { id: "handshake", emoji: "🤝", category: "latam", animation: "bounce", name: "Saludos" },
  { id: "fist", emoji: "👊", category: "latam", animation: "bounce", name: "Puño" },
  { id: "call_me", emoji: "🤙", category: "latam", animation: "float", name: "Llámame" },
];

export const CHARACTER_CATEGORIES = [
  { id: "creativo", name: "Creativos", icon: "✨" },
  { id: "vehiculo", name: "Vehículos", icon: "🚗" },
  { id: "emergencia", name: "Emergencia", icon: "🚨" },
  { id: "mascota", name: "Mascotas", icon: "🐾" },
  { id: "nino", name: "Niños", icon: "🧒" },
  { id: "viaje", name: "Viajes", icon: "✈️" },
  { id: "objeto", name: "Objetos", icon: "🎁" },
  { id: "privacidad", name: "Privacidad", icon: "🔒" },
  { id: "latam", name: "LATAM", icon: "🇵🇪" },
];

export const getCharactersByCategory = (categoryId) => {
  return STICKER_CHARACTERS.filter(c => c.category === categoryId);
};

export const getCharacterById = (characterId) => {
  return STICKER_CHARACTERS.find(c => c.id === characterId) || null;
};

// Animation configs for Framer Motion
export const ANIMATION_CONFIGS = {
  float: {
    animate: { y: [0, -8, 0] },
    transition: { duration: 2, repeat: Infinity, ease: "easeInOut" }
  },
  bounce: {
    animate: { y: [0, -12, 0], scale: [1, 1.05, 1] },
    transition: { duration: 0.6, repeat: Infinity, ease: "easeOut" }
  },
  pulse: {
    animate: { scale: [1, 1.1, 1] },
    transition: { duration: 1.5, repeat: Infinity, ease: "easeInOut" }
  }
};
